import { useLocation } from "react-router-dom";
import { ChatWidget } from "./ChatWidget";

// Site-wide support entry point. Reuses the SAME ChatWidget/tickets backend.
// Hidden on admin/agent back-office areas (they have their own support tools).
export function GlobalSupportWidget() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin") || pathname.startsWith("/agent")) return null;
  return <ChatWidget />;
}
